import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, AlertTriangle } from "lucide-react";

// Cek Kesiapan SPT: daftar hal yang masih perlu dirapikan sebelum lapor (dihitung dari data yang ada)
export function CekKesiapan({ tahun, spt }) {
  const [extra, setExtra] = useState(null);
  useEffect(() => {
    Promise.all([api.get("/akun"), api.get("/pajak-pribadi/settings").catch(() => ({ data: {} })), api.get("/pemasukan")])
      .then(([a, s, p]) => setExtra({ akun: a.data || [], set: s.data || {}, inc: (p.data || []).filter((x) => (x.tanggal || "").startsWith(String(tahun))) }))
      .catch(() => setExtra({ akun: [], set: {}, inc: [] }));
  }, [tahun]);
  if (!extra || !spt) return null;
  const minus = extra.akun.filter((a) => Number(a.saldo) < 0);
  const generic = extra.akun.filter((a) => /^Akun \d+$/.test(a.nama || ""));
  const titip = extra.inc.filter((x) => /titip|pinjam|pengembalian/i.test(`${x.nama_barang} ${x.keterangan || ""}`) && x.perlakuan_pajak !== "bukan_penghasilan");
  const tanpa = extra.inc.filter((x) => !x.jenis_penghasilan || !x.perlakuan_pajak);
  const checks = [
    [!!extra.set.npwp, "NPWP/NIK sudah diisi", "NPWP/NIK belum diisi di Pengaturan Pajak", "/pribadi/pengaturan-pajak"],
    [generic.length === 0, "Semua akun sudah bernama", `${generic.length} akun masih bernama "Akun N"`, "/pribadi/akun"],
    [minus.length === 0, "Tidak ada saldo akun minus", `${minus.length} akun saldonya minus (${minus.map((a) => a.nama).join(", ")}) — isi saldo awal`, "/pribadi/akun"],
    [titip.length === 0, "Titipan/pinjaman sudah dipisahkan", `${titip.length} pemasukan titipan/pinjaman masih dihitung — ubah ke "Bukan Penghasilan"`, "/pemasukan"],
    [tanpa.length === 0, "Semua pemasukan punya jenis pajak", `${tanpa.length} pemasukan belum punya jenis/perlakuan pajak`, "/pemasukan"],
    [(spt.data.l1a?.rows || []).length > 0, "Daftar Harta sudah diisi", "Daftar Harta tahun ini masih kosong", "/pribadi/harta"],
  ];
  const ok = checks.filter((c) => c[0]).length;
  return (
    <div className="rounded-lg border border-slate-200 bg-white p-4 space-y-2" data-testid="cek-kesiapan">
      <div className="flex items-center justify-between"><span className="font-semibold text-slate-800">Cek Kesiapan SPT {tahun}</span>
        <span className="text-[12px] text-slate-500" data-testid="cek-kesiapan-skor">{ok}/{checks.length} siap</span></div>
      <ul className="space-y-1.5">
        {checks.map(([pass, good, bad, to], i) => (
          <li key={i} className="flex items-start gap-2 text-[13px]" data-testid={`cek-item-${i}`}>
            {pass ? <CheckCircle2 size={15} className="mt-0.5 text-emerald-600 shrink-0"/> : <AlertTriangle size={15} className="mt-0.5 text-amber-600 shrink-0"/>}
            <span className={pass ? "text-slate-500" : "text-slate-800"}>{pass ? good : bad}</span>
            {!pass && <Link to={to} className="ml-auto shrink-0 text-[12px] font-medium text-[#166db4] hover:underline">Perbaiki →</Link>}
          </li>
        ))}
      </ul>
    </div>
  );
}
